const initialValuesMetadata = {
    hoursSinceLastSeen: "24",
    sorg: "",
    limit: "100",
    deviceid: ""
  };
  
  export default initialValuesMetadata;